module.exports = __webpack_public_path__ + "static/media/image18.fb2d98f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/image18.png
// module id = 1593
// module chunks = 0